import { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { useTransition, animated } from '@react-spring/web';

interface AnimatedPanelProps {
  children: ReactNode;
  animationKey: string | number;
  className?: string;
}

const AnimatedPanel = ({ children, animationKey, className = '' }: AnimatedPanelProps) => {
  const transitions = useTransition(animationKey, {
    from: { transform: 'translate3d(100%, 0, 0)', opacity: 0 },
    enter: { transform: 'translate3d(0%, 0, 0)', opacity: 1 },
    leave: { transform: 'translate3d(-100%, 0, 0)', opacity: 0 },
    config: { tension: 300, friction: 30 }
  });

  return (
    <Container className={className}>
      {transitions((style, item) => (
        <AnimatedContent key={item} style={style}>
          {children}
        </AnimatedContent>
      ))}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const AnimatedContent = styled(animated.div)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export default AnimatedPanel;
